import { render, staticRenderFns } from "./BeeBreadcrumbs.vue?vue&type=template&id=b4cf5acc"
import script from "./BeeBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./BeeBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./BeeBreadcrumbs.vue?vue&type=style&index=0&id=b4cf5acc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports